import { Tr, type StackProps } from '@chakra-ui/react';

export type UiTrProps = StackProps;

export const UiTr = Tr;
